export const Arrow = ({ className }) => {

    return (
        <svg className={className} width="15" height="9" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.6782 0.734802L7.17822 6.7348L0.678222 0.734802" stroke="#B2B2B2" stroke-width="2" />
        </svg>

    );
};